import React from 'react'
import { useLocation } from 'react-router-dom'
import getPhoenixUrlParams from '../lib/get-phoenix-url-params'
import LoadingPage from '../data/LoadingPage'

export function RedirectToBrandedAppHandler({ children }: { children: React.ReactNode }) {
  const location = useLocation()
  const { redirectToBrandedAppUri, isReturningFromStripe } = getPhoenixUrlParams(location.search)

  // Redirect to branded app after returning from Stripe
  if (isReturningFromStripe && redirectToBrandedAppUri && redirectToBrandedAppUri.startsWith('eversports-brandedapp')) {
    if (typeof window !== 'undefined') {
      const pathname = window.location.pathname.replace(/^\/+/, '')
      const params = new URLSearchParams(window.location.search)
      // Remove the isReturningFromStripe param to avoid redirect loops
      params.delete('isReturningFromStripe')
      window.location.href = `${redirectToBrandedAppUri}${pathname}?${params.toString()}`
    }
    return <LoadingPage />
  }

  return <>{children}</>
}
